import { useState, useEffect } from "react";
import Tab1 from "./ProductionItem/Tab1";
import Table from "./ProductionItem/Table";
import ComingSoon from "./rest/ComingSoon";
import GetIcon from "../../../utils/Icon";
import Button from "../../../Core/Button/Button";
import printerimg from "../../../assets/print.png"
import FormLayout from "../../../Core/Layout/FormLayout";
import ApiResponseBox from "../../../Components/ApiResponseBox";
import { useGetCompanyQuery, useGetCurrencyListQuery } from "../../../store/api/companyapi";
import { useGetBomItemListQuery, usePostCreateBomMutation, usePostSubmitBomMutation, useGetFrappeDocMutation } from "../../../store/api/bomapi";
import OperationLeft from "./Operations/OperationLeft";
import OperationRight from "./Operations/OperationRight";
import Costing from "./Costing/Costing";
import { useNavigate } from "react-router-dom";

const BomForm = ({ bomId }) => {

  const [getFrappeDoc, { data: myData, error: myError }] = useGetFrappeDocMutation();
  const [bomData, setBomData] = useState(null);



  const nvg = useNavigate();
  const [tab, settab] = useState(1)
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error")
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);
  const [withOperations, setwithOperations] = useState(false);
  const [isActive, setisActive] = useState(false);
  const [activityboll, setactivityboll] = useState(false)
  const [isDefault, setisDefault] = useState(false);
  const [AllowAlternativeItem, setAllowAlternativeItem] = useState(false);
  const [rateofsubassembly, setrateofsubassembly] = useState(false);
  const [Quantity, setQuantity] = useState(null);
  const [RateOfMaterials, setRateOfMaterials] = useState("");
  const [po_response, setpo_response] = useState("");
  const [select_bom_item, setselect_bom_item] = useState("");
  const [currency, setcurrency] = useState("");
  const [TMA, setTMA] = useState("");
  const [select_company, setselect_company] = useState("");
  const [selected_item_data, setselected_item_data] = useState([]);
  const [selected_operation_data, setselected_operation_data] = useState([]);
  const { data: bomItemData } = useGetBomItemListQuery();
  const { data: CurrencyData } = useGetCurrencyListQuery();
  const { data: companyData } = useGetCompanyQuery();
  const [createBom] = usePostCreateBomMutation();
  const [SubmitBomApi] = usePostSubmitBomMutation();
  const [fieldErrors, setFieldErrors] = useState({
    bom_item: false,
    company: false,
    currency: false,
    quantity: false,
    rate_of_material: false,
    items: false,
    operations: false,
    TMA: false
  });
  useEffect(() => {
    const fetchDoc = async () => {
      try {
        const payload = {
          doctype: 'BOM',
          name: bomId,
        };
        const response = await getFrappeDoc(payload).unwrap();
        console.log('Frappe Doc Response:', response);
        setBomData(response.message);

        // Set form fields with API data
        if (response.message) {
          setselect_bom_item(response.message.item);
          setselect_company(response.message.company);
          setcurrency(response.message.currency);
          setQuantity(response.message.quantity);
          setRateOfMaterials(response.message.rm_cost_as_per);
          setisActive(response.message.is_active === 1);
          setisDefault(response.message.is_default === 1);
          setAllowAlternativeItem(response.message.allow_alternative_item === 1);
          setrateofsubassembly(response.message.set_rate_of_sub_assembly_item_based_on_bom === 1);
          setwithOperations(response.message.with_operations === 1);
          setTMA(response.message.transfer_material_against);

          // Set items data
          if (response.message) {
            const message = response.message;

            const formattedItems = message.items.map(item => ({
              item_code: item.item_code,
              item: {
                item_code: item.item_code,
                item_name: item.item_name,
                stock_uom: item.uom
              },
              quantity: 1,
              uom: item.uom,
              rate: item.base_rate,
              amount: item.base_amount
            }));

            setselected_item_data(formattedItems);
          }




          // Set operations data if exists
          if (response.message.operations && response.message.operations.length > 0) {
            const opsData = response.message.operations.map(op => ({
              operation_data: { name: op.operation },
              workstation_data: { name: op.workstation },
              operation_time: op.time_in_mins
            }));
            setselected_operation_data(opsData);
          }

          // Set response data
          setpo_response({
            data: {
              name: response.message.name,
              docstatus: response.message.docstatus
            }
          });
          setactivityboll(true);
        }
      } catch (err) {
        console.error('Failed to fetch doc:', err);
      }
    };

    if (bomId) {
      fetchDoc();
    }
  }, [getFrappeDoc, bomId]);
  console.log("selected_item_data", selected_item_data)
  const validateForm = () => {
    const operationsValid = !withOperations || (
      selected_operation_data.length > 0 &&
      selected_operation_data.every(op => (op.operation_time && op.workstation_data?.name && op.operation_data?.name))
    );

    const errors = {
      bom_item: !select_bom_item,
      company: !select_company,
      currency: !currency,
      quantity: !Quantity,
      rate_of_material: !RateOfMaterials,
      items: selected_item_data.length === 0,
      operations: !operationsValid,
      TMA: withOperations && !TMA
    };

    setFieldErrors(errors);
    return !Object.values(errors).some(error => error);
  };

  const CreateBom = async () => {
    if (!validateForm()) {
      setptype("Error");
      setError("Please fill all required fields");
      setShowError(true);
      setTimeout(() => setShowError(false), 4000);
      return;
    }
    setactivityboll(false)
    try {
      const payload = {
        item: select_bom_item,
        quantity: Quantity,
        is_active: isActive ? 1 : 0,
        is_default: isDefault ? 1 : 0,
        rm_cost_as_per: RateOfMaterials,
        allow_alternative_item: 0,
        set_rate_of_sub_assembly_item_based_on_bom: 0,
        items: selected_item_data.map(item => ({
          item_code: item.item_code,
          qty: parseFloat(item.quantity) || 0
        })),
        with_operations: withOperations ? 1 : 0,
        operations: withOperations ? selected_operation_data.map(op => ({
          operation: op.operation_data.name,
          workstation: op.workstation_data.name,
          time_in_mins: op.operation_time
        })) : [],
        TMA: withOperations ? TMA : ""
      };
      const response = await createBom(payload);
      setptype("Message");
      setError("BOM saved successfully!");
      setactivityboll(true);
      setShowError(true);
      console.log("cekc response", response)
      setpo_response(response.data);
    } catch (error) {
      setptype("Error");
      setError(error.data?.message || "Failed to create BOM");
      setShowError(true);
      setTimeout(() => setShowError(false), 4000);
    }
  };

  const SubmitBom = async () => {
    try {
      const response = await SubmitBomApi({ id: po_response.data.name, body: { "docstatus": 1 } });
      setptype("Message");
      setError("BOM submitted successfully!");
      setShowError(true);
      setpo_response(response);
      setfinalstep(true);
      setTimeout(() => { setShowError(false); nvg("/assmbly/bom-list/") }, 2000);
    } catch (error) {
      console.log("check error msg", error)
    }
  }

  return (
    <FormLayout
      title="View Bom"
      breadcrumbs={[
        { label: "Manufacturing" },
        { label: "Bom List", url: "/assmbly/bom-list/" }
      ]}
      status={po_response?.data?.name ? 'Draft' : 'New'}
      finalStep={finalstep}
      actionButtons={""}
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
          <div className="d-flex justify-content-between align-items-end ">

            <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                  Production Item{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                </a>
              </li>
              <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner"  >
                <a className={tab == 2 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(2) }} href="javascript:void(0);">
                  Operations {tab == 2 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                </a>
              </li>
              <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner"  >
                <a className={tab == 3 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(3) }} href="javascript:void(0);">
                  Scrap & Process Loss {tab == 3 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                </a>
              </li>
              <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner"  >
                <a className={tab == 4 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(4) }} href="javascript:void(0);">
                  Costing {tab == 4 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                </a>
              </li>
              <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner"  >
                <a className={tab == 5 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(5) }} href="javascript:void(0);">
                  More Info {tab == 5 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                </a>
              </li>
              <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner"  >
                <a className={tab == 6 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(6) }} href="javascript:void(0);">
                  Website {tab == 6 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                </a>
              </li>
            </ul>

            <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
              <span style={{ position: 'relative', top: '-1px' }}>
                <GetIcon iconName="CgAttachment" size={12} />
              </span>
              <span className=" fw-semibold" style={{ color: "#391F84" }}>
                Attachments
              </span>
            </div>

          </div>
        </div>

        <div className="row justify-content-between" style={{ marginTop: tab == 1 ? '14px' : '0', visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', display: tab == 1 ? "flex" : 'none', flexGrow: '1', overflow: 'hidden' }}>
          {tab == 1 ? <div className="col-3 ">
            <Tab1
              po_response={po_response}
              activityboll={activityboll}
              bomItem={{ bom_item_list: bomItemData?.data, setselect_bom_item, select_bom_item, Error: fieldErrors.bom_item }}
              company={{ company_list: companyData?.result, setselect_company, select_company, Error: fieldErrors.company }}
              currency={{ currency_list: CurrencyData?.data, setcurrency, currency, Error: fieldErrors.currency }}
              Quantity={{ Quantity, setQuantity, Error: fieldErrors.quantity }}
              checkbox={{ rateofsubassembly, setrateofsubassembly, setAllowAlternativeItem, AllowAlternativeItem, setisDefault, isDefault, setisActive, isActive }}
              RateOfMaterial={{ RateOfMaterials, setRateOfMaterials, Error: fieldErrors.rate_of_material }}
            />
          </div> : ''}

          {tab == 1 ? <div className="col-9 d-flex flex-column mt-1">
            <div className="tableLabel">
              <p className="" style={{ color: "#1E1E1E", fontWeight: '500', marginBottom: '4px' }}>
                Raw Materials
              </p>
            </div>
            <Table setselected_item_data={setselected_item_data} selected_item_data={selected_item_data} po_status={po_response} />
          </div> : ''}

        </div>

        <div className="row justify-content-between" style={{ marginTop: tab == 2 ? '14px' : '0', visibility: tab == 2 ? "visible" : 'hidden', height: tab == 2 ? "auto" : '0px', display: tab == 2 ? "flex" : 'none', overflow: 'hidden', flexGrow: '1' }}>
          {tab == 2 ? <div className="col-3 ">
            <OperationLeft
              TMA={{ setTMA, TMA, Error: fieldErrors.TMA }}
              checkbox={{ withOperations, setwithOperations }}
            />
          </div> : ''}

          {tab == 2 ? <div className="col-9 d-flex flex-column mt-1">
            {!withOperations ? '' : <div className="tableLabel">
              <p className="" style={{ color: "#1E1E1E", fontWeight: '500', marginBottom: '4px' }}>
                Operations
              </p>
            </div>}
            <OperationRight setselected_operation_data={setselected_operation_data} withOperations={withOperations} po_status={po_response} checkbox={{ withOperations }} />
          </div> : ''}

        </div>

        <div className="row justify-content-between" style={{ marginTop: tab == 4 ? '14px' : '0', visibility: tab == 4 ? "visible" : 'hidden', height: tab == 4 ? "auto" : '0px', display: tab == 4 ? "flex" : 'none', overflow: 'hidden', flexGrow: '1' }}>
          <div className="col-12 d-flex flex-column mt-1">
            <div className="sidebarbox m-0 px-4 py-2">
              <Costing />
            </div>
          </div>
        </div>

        <div className="row d-flex justify-content-between" style={{ visibility: tab == 3 || tab == 5 || tab == 6 ? "visible" : 'hidden', height: tab == 3 || tab == 5 || tab == 6 ? "auto" : '0px', overflow: 'hidden', flexGrow: '1' }}>
          <ComingSoon />
        </div>

      </div>
      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayout>
  );
};

export default BomForm;